export const guesstimationItemUtil = {
  urlByRef: (ref: string) => `/guesstimationItem/${ref}`,
};
